(() => {
  const CATALOGUE = ['tummyhush-colic-relief-belly-band', 'dreamdots-sleep-sack', 'baby-bunny-hooded-blanket'];
  const TROUBLE = ['delayed', 'exception_address', 'returned_to_sender'];
  function selectUpsell(owned, state, available, mapping = {}) {
    if (TROUBLE.includes(state) || ['no_number', 'not_found', 'api_unreachable', 'pre_dispatch'].includes(state)) return null;
    if (!Array.isArray(owned)) return null;
    const preferred = owned.includes(CATALOGUE[0]) ? mapping.band : owned.includes(CATALOGUE[1]) ? mapping.dreamdots : mapping.other;
    return [preferred, ...CATALOGUE].find(h => CATALOGUE.includes(h) && !owned.includes(h) && available.includes(h)) || null;
  }
  function safePresentation(data, today = new Intl.DateTimeFormat('en-CA', {timeZone:'America/New_York',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date())) {
    if (data.eta?.to && data.eta.to < today && data.state !== 'delivered') return {...data, state:'delayed', eta:null};
    return TROUBLE.includes(data.state) || data.state === 'delivered' ? {...data, eta:null} : data;
  }
  class ThTracking extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.copy = JSON.parse(this.querySelector('[data-config]').textContent);
      this.status = this.querySelector('[data-status]');
      this.sequence = 0;
      this.querySelectorAll('form').forEach(form => form.addEventListener('submit', event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const query = new URLSearchParams(new FormData(form));
        this.clearAddress();
        this.lookup(query, true);
      }));
      const params = new URLSearchParams(location.search);
      const query = new URLSearchParams();
      // Editor fixtures are emitted by Liquid only in request.design_mode.
      if (this.dataset.forceState) return this.render(this.fixture(this.dataset.forceState));
      for (const key of ['n','t','order','email']) if (params.has(key)) query.set(key, params.get(key));
      if (!query.has('n') && !query.has('t') && params.has('nums')) query.set('n', params.get('nums').split(',')[0].trim());
      if ([...query].length) {this.clearAddress();this.lookup(query);}
      else this.render({state:'no_number', milestones:[]});
    }
    disconnectedCallback() {this.controller?.abort();}
    clearAddress() {
      const url = new URL(location.href);
      for (const key of ['n','nums','t','order','email']) url.searchParams.delete(key);
      try {history.replaceState(null, '', url.pathname + url.search + url.hash);} catch { /* Embedded browsers may restrict history. */ }
    }
    fixture(state) {
      const date = offset => {const d = new Date();d.setUTCDate(d.getUTCDate()+offset);return d.toISOString().slice(0,10);};
      const ranks = {pre_dispatch:0,dispatched_no_movement:1,in_transit_quiet:1,in_region:2,arriving_locally:2,out_for_delivery:2,delivered:3,delayed:1,exception_address:2,returned_to_sender:1};
      const rank = ranks[state];
      return {state, timeline:rank===undefined?[]:[{key:state==='delivered'?'delivered':'transport',date:date(-1)},{key:'sorting',date:date(-2)},{key:'packed',date:date(-3)}], order_name:'#4033', eta: ['dispatched_no_movement','in_transit_quiet','in_region','arriving_locally','out_for_delivery'].includes(state) ? {from:date(state==='out_for_delivery'?0:8),to:date(state==='out_for_delivery'?0:13)} : null,
        milestones:rank===undefined?[]:['packed','on_the_way','in_your_area','delivered'].map((key,i)=>({key,done:i<=rank,current:i===rank})),owned_product_handles:[CATALOGUE[0]],carrier_display:state==='delivered'?'USPS':null};
    }
    async lookup(query, focus = false) {
      this.controller?.abort();
      const sequence = ++this.sequence;
      this.controller = new AbortController();
      this.querySelector('[data-upsell]').hidden = true;
      this.querySelector('[data-skeleton]').hidden = false;
      this.status.hidden = true;
      this.status.setAttribute('aria-busy','true');
      const timer = setTimeout(() => this.controller?.abort(), 8000);
      try {
        if (!this.copy.api_url) throw Error();
        const url = new URL(this.copy.api_url);
        if (url.protocol !== 'https:' && !(url.protocol==='http:' && ['127.0.0.1','localhost'].includes(url.hostname))) throw Error();
        url.pathname = '/api/public/track';url.search=query.toString();url.hash='';
        const response = await fetch(url, {method:'GET',credentials:'omit',referrerPolicy:'no-referrer',cache:'no-store',signal:this.controller.signal});
        if (!response.ok) throw Error();
        const data = await response.json();
        if (sequence === this.sequence) this.render(data, focus);
      } catch {if (sequence === this.sequence) this.render({state:'api_unreachable',milestones:[]}, focus);}
      finally {clearTimeout(timer);}
    }
    date(value) {
      return new Intl.DateTimeFormat(document.documentElement.lang || 'en', {month:'short',day:'numeric',timeZone:'UTC'}).format(new Date(value+'T12:00:00Z'));
    }
    render(input, focus = false) {
      let data = safePresentation(input);
      if (!Object.hasOwn(this.copy, data.state+'_title')) data = {state:'api_unreachable',milestones:[]};
      const state=data.state, c=this.copy;
      const text=(selector,value)=>{const node=this.querySelector(selector);node.textContent=value||'';node.hidden=!value;};
      text('[data-title]',c[state+'_title']);
      text('[data-body]',c[state+'_body']);
      let follow=c[state+'_follow']||'';
      follow=follow.replace('{date}',data.eta?.to?this.date(data.eta.to):c.date_fallback);
      text('[data-follow]',follow);
      text('[data-order]',data.order_name ? c.order_label+' '+data.order_name : '');
      text('[data-eta]',data.eta? c.arriving_label+' '+(data.eta.from===data.eta.to?c.today_label:this.date(data.eta.from)+' – '+this.date(data.eta.to)):'');
      text('[data-carrier]',data.milestones?.length ? c.carrier_label+' '+(data.carrier_display||c.delivery_partner)+(data.reference?' · '+c.reference_label+' '+data.reference:''):'');
      this.querySelector('[data-quiet-help]').hidden = !['in_transit_quiet','dispatched_no_movement'].includes(state);
      const rail=this.querySelector('[data-rail]');rail.replaceChildren();
      const keys=['packed','on_the_way','in_your_area','delivered'];
      if(data.milestones?.length) for(const key of keys) {
        const item=data.milestones.find(m=>m.key===key)||{};
        const li=document.createElement('li');li.className=item.done?'is-done':'';
        if(item.current) li.setAttribute('aria-current','step');
        const label=document.createElement('span');label.textContent=c['milestone_'+key];li.append(label);
        const status=document.createElement('small');status.textContent=item.current?c.rail_current:item.done?c.rail_done:c.rail_pending;li.append(status);
        if(item.date) {const time=document.createElement('time');time.dateTime=item.date;time.textContent=this.date(item.date);li.append(time);}
        rail.append(li);
      }
      const timeline=this.querySelector('[data-timeline]');timeline.replaceChildren();
      const allowed=['packed','sorting','departed','moving','transport','network','local','out_for_delivery','delivered'];
      for(const event of [...(data.timeline||[])].filter(e=>allowed.includes(e.key)&&/^\d{4}-\d{2}-\d{2}$/.test(e.date)).sort((a,b)=>b.date.localeCompare(a.date))) {
        if(!c['timeline_'+event.key]) continue;
        const li=document.createElement('li'),time=document.createElement('time'),label=document.createElement('span');
        time.dateTime=event.date;time.textContent=this.date(event.date);
        label.textContent=c['timeline_'+event.key];li.append(time,label);timeline.append(li);
      }
      this.querySelector('[data-timeline-wrap]').hidden=!timeline.children.length;
      const templates=[...this.querySelectorAll('template[data-product]')];
      const handle=selectUpsell(data.owned_product_handles,state,templates.map(t=>t.dataset.product),{band:c.band_suggestion,dreamdots:c.dreamdots_suggestion,other:c.other_suggestion});
      const upsell=this.querySelector('[data-upsell]');upsell.replaceChildren();upsell.hidden=!handle;
      if(handle) upsell.append(templates.find(t=>t.dataset.product===handle).content.cloneNode(true));
      this.querySelector('[data-skeleton]').hidden=true;
      this.status.hidden=false;this.status.setAttribute('aria-busy','false');
      if(focus) this.querySelector('[data-title]').focus();
    }
  }
  if (!customElements.get('th-tracking')) customElements.define('th-tracking', ThTracking);
})();
